import React from 'react'

interface ITrendIconProps {
  stroke?: string
}

export const AppDownTrendIcon = ({ stroke = '#121212' }: ITrendIconProps) => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.875 1L6.5 6.625L10.0718 3.05319C11.768 4.34715 13.0651 6.19164 13.6599 8.41178L14.307 10.8266M14.307 10.8266L16.9586 6.2338M14.307 10.8266L9.7142 8.17494"
        stroke={stroke}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
